export const ACTION_TO_ACTION = 'action_to_action';
export const ACTION_BOTTOM_SHEET = 'actions_bottom_sheet';
export const ITEMS_SELECTION_WITH_MODIFIERS = 'items_selection_with_modifiers';
export const RESOLUTION_SELECTION = 'resolution_selection';
export const CLOSABLE_ACTION = 'closable_action';
export const FEEDBACK_SCORE = 'feedback_score';
export const FEEDBACK_TEXT = 'feedback_text';
export const EMAIL = 'email';
export const CALL_NUMBER = 'call_number';
export const LIVE_CHAT = 'live_chat';
export const DIALOG = 'dialog';
export const CANCEL_ORDER = 'cancel_order';
export const EMPTY_STATE = 'empty_state';
export const CLOSE_ORDER_HELP = 'close_order_help';

export const SUB_TEMPLATES = [LIVE_CHAT, DIALOG];

export const BACKTRACK_TEMPLATES = [ACTION_TO_ACTION, CLOSABLE_ACTION];

export const FINAL_ACTIONS = [LIVE_CHAT];

export const ACTION_INVOKING_TEMPLATES = [CLOSE_ORDER_HELP];
